import { render, staticRenderFns } from "./CurrencyEditor.vue?vue&type=template&id=3dafd900&scoped=true&"
import script from "./CurrencyEditor.vue?vue&type=script&lang=js&"
export * from "./CurrencyEditor.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyEditor.vue?vue&type=style&index=0&id=3dafd900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dafd900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dafd900')) {
      api.createRecord('3dafd900', component.options)
    } else {
      api.reload('3dafd900', component.options)
    }
    module.hot.accept("./CurrencyEditor.vue?vue&type=template&id=3dafd900&scoped=true&", function () {
      api.rerender('3dafd900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FinanceManage/AccountingDocument/components/CurrencyEditor.vue"
export default component.exports